module.exports = __webpack_public_path__ + "static/screen-implementation-9a46c14c3a1657cc5f0d50c75b0336f9.png";